import { useTranslation } from "react-i18next"

import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

interface ExampleXlsxLinkProps {
  url?: string
}

export function ExampleXlsxLink({ url }: ExampleXlsxLinkProps) {
  const { t } = useTranslation()

  if (!url) return null

  return (
    <a href={url} download className="new-project-overlay__xlsx-example-link">
      <Icon name={IconName.DOWNLOAD} />
      {t("NewProjectOverlay.XlsxUpload.ExampleLink")}
    </a>
  )
}
